export function countSubstring(str: string, substring: string): number {
    return str.split(substring).length - 1;
}